/**
 * Created by Dhanya Akhil on 1/30/2017.
 */
import {
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DEFAULT_INTERRUPTSOURCES, Idle } from "@ng-idle/core";
import { Keepalive } from "@ng-idle/keepalive";
import { AppComponent } from "../../../app.component";
import {
  AccountResourceService,
  LoginService,
  PrincipalService,
  ProfileService,
  WindowRef,
} from "../../../shared";
import { AccountType } from "../../../shared/types/account.type";
import { Router } from "@angular/router";
import { Account } from "../../balance/types/account.type";

@Component({
  selector: "navbar",
  templateUrl: "navbar.component.html",
  styleUrls: ["navbar.component.scss"],
  host: {
    "(document:click)": "handleClick($event)",
  },
})
export class NavbarComponent implements OnInit {
  public isNavbarCollapsed = true;
  public elementRef;
  private _window: Window;
  public highlightedDiv: number;
  public account: AccountType;
  public idleStatus: boolean;
  public idleCountdownLogout: number;
  isMobile: boolean;
  mobileMenu: boolean = false;

  public authenticatedMenus;
  private isEmployee: boolean = false;
  private isEmployer: boolean = false;
  private isSupport: boolean = false;
  private isAdmin: boolean = false;

  idleState = "Not started.";
  timedOut = false;
  lastPing: Date = null;
  public languages;
  langFinal = [];

  constructor(
    private app: AppComponent,
    public principal: PrincipalService,
    private loginService: LoginService,
    public myElement: ElementRef,
    private windowRef: WindowRef,
    public router: Router,
    public translate: TranslateService,
    private idle: Idle,
    private keepalive: Keepalive,
    private _applicationRef: ApplicationRef,
    private ref: ChangeDetectorRef,
    public accontServie: AccountResourceService,
    private principalService: PrincipalService,
    public profileService: ProfileService
  ) {

    this.idleStatus = false;
    this.idleCountdownLogout = 100;
    this.mobileMenu = false

    translate.addLangs(["en", "id"]);
    translate.setDefaultLang("en");
    this.languages = translate.getLangs();
    for (var i = 0; i < this.languages.length; i++) {
      if (this.languages[i] == "id") {
        this.langFinal.push({ key: "id", value: "Bahasa" });
      }
      if (this.languages[i] == "en") {
        this.langFinal.push({ key: "en", value: "English" });
      }
    }
    let browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|id/) ? browserLang : "en");
    idle.setIdle(30);
    //idle.setIdle(10);
    //idle.setTimeout(10);
    idle.setTimeout(5 * 60 - 30);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = "No longer idle.";
      console.log(this.idleState);
      this.idleStatus = false;
      this.idleCountdownLogout = 100;
    });
    idle.onIdleStart.subscribe(() => {
      this.idleState = "You've gone idle!";
      console.log(this.idleState);
      this.idleStatus = true;
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = "You will time out in " + countdown + " seconds!";
      this.idleCountdownLogout = countdown;
    });
    idle.onTimeout.subscribe(() => {
      this.idleState = "Timed out!";
      this.timedOut = true;
      var currentPath = window.location.hash;
      let loginHash = "#/login";
      let forgotHash = "#/forgotpassword";
      if (
        currentPath == loginHash ||
        currentPath == forgotHash ||
        currentPath.startsWith("#/employeeactivate")
      ) {
        this.reset();
      } else {
        this.reset();
        const timeOutFlag = true;
        this.logout(timeOutFlag);
      }
    });
    this.reset();
    this.elementRef = myElement;
    this._window = windowRef.nativeWindow;

    // this.principalService.identity(true).then(
    //   (account: Account) => {
    //     if (account == null) {
    //       this.router.navigate(["login"]);
    //     } else {
    //       const userRole = account.authorities[0];
    //       if (userRole == this.ROLE_EMPLOYEE) {
    //         this.isEmployee = true;
    //       }
          
    //     }
    //   },
    //   (error) => {
    //     this.router.navigate(["login"]);
    //   }
    // );
  }

  ngOnInit() {
    this.autheMenu();
    this.highlightedDiv = 1;
    this.isMobile = this.windowRef.isMobile;
    const localMenu = localStorage.getItem('menu');
    const obj = JSON.parse(localMenu)
    this.authenticatedMenus = obj
  }

  ngOnDestroy(){
    this.mobileMenu = false
  }

  setMenuState(event){
    this.mobileMenu = event;
  }

  public autheMenu() {
  //  this.profileService.getAuthenticatedMenus().subscribe((menu) => {
  //     this.authenticatedMenus = menu;
  //   });
  }

  public reset() {
    this.idle.watch();
    this.idleState = "Started.";
    this.timedOut = false;
    this.idleStatus = false;
    this.idleCountdownLogout = 100;
  }
  public toggleHighlight(newValue: number, flag) {
    if (this.highlightedDiv === newValue) {
      this.highlightedDiv = newValue;
    } else {
      if (flag != "home" && this.highlightedDiv === newValue) {
        this.highlightedDiv = 0;
      } else {
        this.highlightedDiv = newValue;
      }
    }
  }

  handleNavMenu() {
    this.mobileMenu = !this.mobileMenu;
  }

  isActive(viewLocation) {
    var path = this.router.url;
    let currentMailUrl = path.split("/");
    var active = viewLocation === currentMailUrl[1];
    return active;
  }

  handleClick(event) {
    var clickedComponent = event.target;
    var inside = false;
    do {
      if (clickedComponent === this.elementRef.nativeElement) {
        inside = true;
      }
      clickedComponent = clickedComponent.parentNode;
    } while (clickedComponent);
    if (inside) {
    } else {
      this.app.menu1Opened = false;
      this.app.menu2Opened = false;
      this.app.menu3Opened = false;
      this.app.menu4Opened = false;
      this.app.menu5Opened = false;
    }
  }

  public toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  public collapseNavbar() {
    this.app.menu1Opened = false;
    this.app.menu2Opened = false;
    this.app.menu3Opened = false;
    this.app.menu4Opened = false;
    this.app.menu5Opened = false;

    this.isNavbarCollapsed = true;
  }

  public isAuthenticated() {
    return this.principal.isAuthenticated();
  }
  logout(timout) {
    this.account = null;
    this.principal.authenticate(null);
    this.loginService.logout(timout);
  }
}
